const languageEditorActionTypes = {
    SET_LANGUAGE_BEING_EDITED: "SET_LANGUAGE_BEING_EDITED",
    RETRIEVED_ROOT_RESOURCES_FOLDER: "RETRIEVED_ROOT_RESOURCES_FOLDER",
    RETRIEVED_SUBROOT_RESOURCES_FOLDER: "RETRIEVED_SUBROOT_RESOURCES_FOLDER",
    RETRIEVED_RESX_ENTRIES: "RETRIEVED_RESX_ENTRIES",
    UPDATED_RESX_ENTRIES: "UPDATED_RESX_ENTRIES"
};
export default languageEditorActionTypes;